import {
  CLEAR_FLAGS_PARAMETROS_INTEGRACAO,
  GET_PARAMETROS_INTEGRACAO_INIT,
  GET_PARAMETROS_INTEGRACAO_SUCCESS,
  ERROR_PARAMETROS_INTEGRACAO_MSG,
  UPDATE_PARAMETROS_INTEGRACAO_SUCCESS,
  UPDATE_PARAMETROS_INTEGRACAO_INIT,
  VALIDAR_DADOS_PGLOADER_INIT,
  VALIDAR_DADOS_PGLOADER_SUCCESS
} from '../../actionTypes';

export const getParametrosIntegracaoInit = (data) => ({
  type: GET_PARAMETROS_INTEGRACAO_INIT,
  payload: data
});

export const getParametrosIntegracaoSuccess = (data) => {
  return {
    type: GET_PARAMETROS_INTEGRACAO_SUCCESS,
    payload: data
  };
};

export const updateParametrosIntegracaoInit = (data) => ({
  type: UPDATE_PARAMETROS_INTEGRACAO_INIT,
  payload: data
});

export const updateParametrosIntegracaoSuccess = (data) => ({
  type: UPDATE_PARAMETROS_INTEGRACAO_SUCCESS,
  payload: data
});

export const validarDadosPgloaderInit = (data) => ({
  type: VALIDAR_DADOS_PGLOADER_INIT,
  payload: data
});

export const validarDadosPgloaderSuccess = (data) => ({
  type: VALIDAR_DADOS_PGLOADER_SUCCESS,
  payload: data
});

export const clearFlagsParametrosIntegracao = () => ({
  type: CLEAR_FLAGS_PARAMETROS_INTEGRACAO,
  payload: {}
});

export const errorParametrosIntegracaoMsg = (data) => ({
  type: ERROR_PARAMETROS_INTEGRACAO_MSG,
  payload: data
});


